// extracted by mini-css-extract-plugin
module.exports = {"popover":"styles_popover__23YBa","popoverScrollContainer":"styles_popoverScrollContainer__1Neex","menuItems":"styles_menuItems__Z4sxG","animation":"styles_animation__3anEV"};